export enum PaymentDashboardAnalyticsMessages {
  capability = 'payments',
  pageLoadedEvent = 'page loaded',
  outboundLinkEvent = 'outbound link click',
  tileClick = 'button click',
  pageName = 'us foods:r4:seller dashboard',
  searchTerm = 'search on seller dashboard',
  modalOpen = 'modal open',
  modalName = 'seller dashboard filter',
}
